import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { VhostProvider } from '../../../common/contexts/VhostContext';
import defaultTheme from '../../../PlekReact/designSystem/theme/defaultTheme';

export interface LoginWrapperProps {
	children: React.ReactNode;
}

const GlobalStyle = createGlobalStyle`
	body {
		// todo: write a correct type for theme
		background: ${({ theme }: any) => (theme.login.backgroundImage ? `url(${theme.login.backgroundImage}) no-repeat center bottom / cover fixed` : '')};
		background-color: ${({ theme }: any) => theme.login.backgroundColor || ''};
	}
`;

export const LoginWrapper: React.FC<LoginWrapperProps> = ({ children }) => {
	return (
		<BrowserRouter>
			<VhostProvider>
				<ThemeProvider theme={defaultTheme}>
					<GlobalStyle />

					{children}
				</ThemeProvider>
			</VhostProvider>
		</BrowserRouter>
	);
};
